exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.countdown_student__timer-intro--3Gw7v {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #52c4ff;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1020;\n}\n\n.countdown_student__loading--oDDiA {\n\tcolor: #ffffff;\n\tfont-family: 'avenirheavy', Helvetica, Arial, sans-serif;\n\tfont-size: 30px;\n\tmargin-top: 45%;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\ttransform: translateY(-50%);\n}\n", ""]);

// exports
exports.locals = {
	"timer-intro": "countdown_student__timer-intro--3Gw7v",
	"loading": "countdown_student__loading--oDDiA"
};